import types from '../constants/types'
import config from '@/config'
import cookies from 'js-cookie'
import { toQueryString } from '@/utils'
import axios from 'axios'

export const recordAction = {
  fetchRecord ({ dispatch, commit, state, rootState }, param, apiParam = config.apiParam) {
    const request = param.request || param.path
    commit(types.FETCH_RECORD_REQUEST, { request: request })
    axios({
      method: 'post',
      baseURL: config.serviceHost,
      url: '/' + config.apiVersion + '/' + param.path,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      transformRequest: [function (data, headers) {
        return toQueryString(data)
      }],
      timeout: 60000,
      data: Object.assign(
        {channel_token: cookies.get('channel') },
        param.data,
        apiParam)
    })
      .then((res) => {
        if (res && res.status === 200) {
          if (res.data.code !== '000000' && res.data.code !== '0') {
            commit(types.FETCH_RECORD_FAILURE, {
              request: request,
              data: res.data
            })
            if (typeof param.onFail === 'function') {
              param.onFail(res.data)
            }
          } else {
            commit(types.FETCH_RECORD_SUCCESS, {
              request: request,
              data: res.data
            })
            if (typeof param.onSuccess === 'function') {
              param.onSuccess(res.data)
            }
          }
        }
      })
      .catch((error) => {
        commit(types.FETCH_RECORD_FAILURE, {
          request: request,
          data: error
        })
        if (typeof param.onFail === 'function') {
          if (config.debug) {
            param.onFail({ msg: JSON.stringify(error) })
          } else {
            param.onFail({ msg: '服务器无响应' })
          }
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/fetchrecord.js